import { lazy, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import VendorInvoices from "../views/finance/VendorInvoices";
import Vendorbills from "../views/finance/vendor-bills";
import { ConfigProvider, Layout, theme } from "antd";
import {
  FileTextOutlined, // for Vendor Invoices
  FileDoneOutlined, // for Vendor Bills
} from "@ant-design/icons";
import AppSidebar from "../widgets/sideBar";
import AppHeader from "../widgets/header";
const Dashboard = lazy(() => import("../views/finance/Dashboard"));

const { Content } = Layout;
export default function Finance() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState(
    location.pathname.replace(`/finance`, "")
  );
  const menuItems = [
    // {
    //   key: "/dashboard",
    //   icon: <PieChartOutlined />,
    //   label: "Dashboard",
    //   path: "/dashboard",
    // },
    {
      key: "/vendor-invoices",
      icon: <FileTextOutlined />,
      label: "Vendor Invoices",
      path: "/vendor-invoices",
    },
    {
      key: "/vendor-bills",
      icon: <FileDoneOutlined />,
      label: "Vendor Bills",
      path: "/vendor-bills",
    },
  ];
  return (
    <>
      {/* <Suspense fallback={<Loader />}>
        <SidebarFinance />
        <div className="relative md:ml-64 bg-blueGray-100">
          <div className="px-4 md:px-10 mx-auto w-full min-h-[455px] bg-[#e3f2f9]">
            <Routes>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="vendor-invoices" element={<VendorInvoices />} />
              <Route path="vendor-bills" element={<Vendorbills />} />
            </Routes>
          </div>
          <FooterAdmin />
        </div>
      </Suspense> */}

      {/* - - - - - NEW - - - - - */}
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: "#0471a3",
            colorBgContainer: "rgba(255, 255, 255, 0.9)",
            borderRadius: 12,
          },
          components: {
            Layout: {
              siderBg: "rgba(255, 255, 255, 0.95)",
              headerBg: "rgba(255, 255, 255, 0.9)",
            },
            Menu: {
              itemBg: "transparent",
              itemSelectedBg: "#0471a3",
              itemSelectedColor: "#ffffff",
              itemHoverBg: "rgba(97, 146, 105, 0.1)",
              itemHoverColor: "#0471a3",
              groupTitleColor: "#8c8c8c",
              groupTitleFontSize: "12px",
            },
          },
        }}
      >
        <Layout style={{ minHeight: "100vh" }}>
          <AppSidebar
            collapsed={collapsed}
            menuItems={menuItems}
            role={"finance"}
            selectedKeys={selectedKeys}
            setCollapsed={setCollapsed}
            setSelectedKeys={setSelectedKeys}
          />
          <Layout style={{ marginLeft: collapsed ? 80 : 280 }}>
            {/* <Layout> */}
            {/* - - - - - H E A D E R - - - - - */}
            <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} />
            {/* - - - C O N T E N T - - - - - */}
            <Content
              style={{
                margin: collapsed ? "16px" : "32px",
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                minHeight: "calc(100vh - 144px)",
                borderRadius: "24px",
                position: "relative",
                overflow: "hidden",
                transition: "all 0.3s ease",
              }}
            >
              {/* Background decoration */}
              <div
                style={{
                  position: "absolute",
                  top: "-50%",
                  right: "-20%",
                  width: "600px",
                  height: "600px",
                  background:
                    "radial-gradient(circle, rgba(4, 113, 163, 0.03) 0%, transparent 70%)",
                  borderRadius: "50%",
                  zIndex: 0,
                }}
              />

              <div style={{ position: "relative", zIndex: 1, padding: "40px" }}>
                <Routes>
                  {/* <Route path="dashboard" element={<Dashboard />} /> */}
                  <Route path="vendor-invoices" element={<VendorInvoices />} />
                  <Route path="vendor-bills" element={<Vendorbills />} />
                </Routes>
              </div>
            </Content>
            {/* - - - F O O T E R - - - - - */}
            {/* <AppFooter /> */}
          </Layout>
        </Layout>
      </ConfigProvider>
    </>
  );
}
